import { default as animationData } from './animation-data.json';

import Lottie from 'react-lottie/dist';

export const HeroAnimation = () => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return <Lottie options={defaultOptions} width={'100%'} isClickToPauseDisabled />;
};
